<table class="table-responsive view-form-array-table">
	<tr class="data-header">
		<th class="data-column" *ngFor="let column of columns; let i = index"
			[ngClass]="{mailClass:column[i]=='Email'}">
			{{column}}
		</th>
	</tr>
	<tr class="data-row" *ngFor="let row of _rows;">
		<td *ngFor="let key of rowValueNames; let n = index;" [ngClass]="{mailClass:key[n]=='Email'}">
			{{row[key]}}
		</td>
	</tr>
</table>